export default "__VITE_ASSET__DYe0q9Vp__"